import { useEffect, useState } from "react";

export const useAfterInit = (): boolean => {
  // state
  const [afterInit, setAfterInit] = useState(false);

  //  side-effects
  useEffect(() => {
    setAfterInit(true);
  }, []);

  // return
  return afterInit;
}